/**
 * Utility function to get specific cookie value by name
 *
 * @param {string} cookieName targeted cookie to retrieve its key value
 */

const HEX_BASE = 16;
const CHAR_LIMIT = 2;

export const getCookieValue = (cookieName) => {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        const c = cookieArray[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

/**
 * general hash method for secured encryption using the SHA-256 algorithm via the Web Crypto API.
 * @param {string} value - The value to be hashed.
 * @returns {string} - The value turned into a hashed string.
 */
export const hashValue = async (value) => {
    if (!value) {
        return null;
    }
    try {
        if (window?.crypto) {
            const encoder = new TextEncoder();
            const data = encoder.encode(value);
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map((byte) => byte.toString(HEX_BASE).padStart(CHAR_LIMIT, '0')).join('');
            return hashHex;
        }
        return null;
    } catch (error) {
        return null;
    }
};
